import createPersistedState from "use-persisted-state";

export const useOrgStorage = createPersistedState("zeet_ghorg"); // cspell:disable-line
